import _util from '../utils';
import apiUrl from '../utils/api-url';
const axios = require('axios')
const interactionApi = {
  getVideoList(resolve, reject) {
    const current_lang = _util.getCurrentLang()
    var url = apiUrl.url + '/api/' + current_lang + '/videos'
    axios.get(url)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  },

  getCommentList(resolve, reject) {
    const current_lang = _util.getCurrentLang()
    var url = apiUrl.url + '/api/' + current_lang + '/site_comments'
    axios.get(url)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  }
}

export default interactionApi



// WEBPACK FOOTER //
// ./src/api/interaction-api.js